import { useMemo } from 'react';

function useBrowserCheck() {
  var _navigator;

  const userAgent = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;
  return useMemo(() => {
    const isFirefox = userAgent.includes('Firefox');
    const isChromium = userAgent.includes('Chrome');
    const isSafari = userAgent.includes('Safari') && !isChromium;
    return {
      isFirefox,
      isChromium,
      isSafari
    };
  }, [userAgent]);
}

export { useBrowserCheck };
